import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconography, {
  IconographySizes,
} from '@hid-galaxy-ui/galaxy-react/components/Iconography';
import { useTranslation } from 'react-i18next';

import {
  projectIdSelector,
  tenantIdSelector,
} from '../../store/selectors/formSessionSelectors';
import PhotoRequirementsDialog from './PhotoRequirementsDialog';
import { usePhotoRequirementsDialogStyles } from './photoRequirementsDialogStyles';

export interface IPhotoRequirementsTriggerProps {
  className?: string;
}

const PhotoRequirementsTrigger: React.FC<IPhotoRequirementsTriggerProps> = ({
  className,
}) => {
  const classes = usePhotoRequirementsDialogStyles();
  const { t } = useTranslation();
  const projectId = useSelector(projectIdSelector);
  const tenantId = useSelector(tenantIdSelector);
  const [open, setOpen] = useState(false);

  if (!projectId) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className={className ?? classes.helpLink}
        onClick={() => setOpen(true)}
      >
        <Iconography
          icon="circleInfo"
          size={IconographySizes.Small}
          className={classes.helpLinkIcon}
        />
        {t('PHOTO_REQUIREMENTS_LINK') as string}
      </button>

      <PhotoRequirementsDialog
        open={open}
        projectId={projectId}
        tenantId={tenantId}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default PhotoRequirementsTrigger;
